<afoone-breadcrumb
  [hideBackButton]="true"
  [breadcrumbItems]="[
    {
      label: 'WXRL.LOGS',
    }
  ]"
></afoone-breadcrumb>

<div *ngIf="wxrlUnauthorized" class="wxrl-unauthorized-message">
  <p-message severity="warn" [text]="'WXRL.NOT_AUTHORIZED' | translate"></p-message>
  <p-button
    [label]="'WXRL.GO_TO_HOME' | translate"
    icon="pi pi-home"
    (click)="goToHome()"
    styleClass="p-button-outlined"
  ></p-button>
</div>

<ng-container *ngIf="!wxrlUnauthorized">
<afoone-wxrl-rule-logs-filters
  (search)="onSearch($event)"
  [fixedRule]="!!rule"
  [totalOccurrences]="totalOccurrences"
></afoone-wxrl-rule-logs-filters>

<div class="export-button">
  <button
    pButton
    type="button"
    icon="pi pi-file-export"
    label="Exportar CSV"
    class="p-button-outlined p-button-secondary"
    (click)="exportCsv()"
    *ngIf="logs && logs.length > 0"
    style="margin-bottom: 0.5rem"
  ></button>
</div>

<p-table
  #dt
  [value]="logs"
  [paginator]="true"
  [rows]="100"
  [rowsPerPageOptions]="[50, 100, 200]"
  [globalFilterFields]="['name', 'description']"
  [scrollable]="true"
  scrollHeight="400px"
>
  <ng-template pTemplate="header">
    <tr>
      <th field="timeWhen" id="field-time-when" style="min-width: 180px">
        {{ "WXRL.LOG.DATE_TIME" | translate }}
      </th>
      <th field="auftrNr" id="field-auftr-nr">
        {{ "WXRL.LOG.REQUEST_ID" | translate }}
      </th>
      <th field="einDat" id="field-ein-dat">
        {{ "WXRL.LOG.REQUEST_DATE" | translate }}
      </th>
      <th field="ruleNr" id="field-rule-nr">
        {{ "WXRL.RULE.TITLE" | translate }}
      </th>
      <th field="what" id="field-what">
        {{ "WXRL.LOG.TRACEABILITY_RECORD" | translate }}
      </th>
    </tr>
  </ng-template>
  <!-- Body -->
  <ng-template pTemplate="body" let-item>
    <tr>
      <td>{{ item.timeWhen | date : "dd/MM/yyyy HH:mm:ss.SSS" }}</td>
      <td>{{ item.auftrNr }}</td>
      <td>{{ item.einDat | date : "dd/MM/yyyy" }}</td>
      <td>{{ item.ruleNr }}</td>
      <td [innerHTML]="item.what | highlight : wordSearch"></td>
    </tr>
  </ng-template>
</p-table>
</ng-container>
